<template>
    <div class="box">
        <el-form
            :model="form"
            ref="form"
            size="medium"
            label-width="100px"
            class="demo-dynamic"
        >
            <el-form-item
                class="name"
                prop="profitname"
                label="受益人"
                :rules="[
                    {
                        required: true,
                        message: '请输入受益人名称',
                        trigger: 'blur',
                    },
                ]"
            >
                  <name-search v-model.trim="form.profitname"></name-search>
            </el-form-item>

            <el-form-item
                class="product"
                prop="productname"
                label="产品类型"
                :rules="[
                    {
                        required: true,
                        message: '请选择产品类型',
                        trigger: 'change',
                    },
                ]"
            >
                <el-select 
                    ref="select" 
                    v-model="form.productname" 
                    :popper-append-to-body="false" 
                    popper-class="product-select" 
                    clearable multiple 
                    placeholder="请选择产品类型"
                    @change=selectChange>
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.label">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item
                prop="pushstarttime"
                label="持续时间"
                :rules="[
                    {
                        required: true,
                        message: '请选择时间',
                        trigger: 'change',
                    },
                ]"
            >   
                <el-date-picker
                    v-model="time"
                    type="datetimerange"
                    range-separator="至"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    start-placeholder="持续时间早至"
                    end-placeholder="持续时间晚至">
                </el-date-picker>
            </el-form-item>

            <el-form-item
                v-for="(email, index) in form.receivers"
                :label="'邮箱' + (index+1)"
                :key="email.key"
                :prop="'receivers.' + index + '.value'"
                :rules="[
                    {
                        required: true,
                        message: '请输入邮箱地址',
                        trigger: 'blur',
                    },
                    {
                        type: 'email',
                        message: '请输入正确的邮箱地址',
                        trigger: ['blur', 'change'],
                    },
                ]"
            >
                <el-input v-model.trim="email.value" clearable></el-input>
                <el-button type="primary" icon="el-icon-plus" v-if="index == form.receivers.length-1" @click.prevent="addEmail">新增</el-button>
                <el-button type="danger" icon="el-icon-delete" v-if="index != 0" @click.prevent="removeEmail(email)">删除</el-button>
            </el-form-item>

            <el-form-item label-width="0px" size="medium">
                <div class="sumbit-btn">
                    <el-button
                        type="success"
                        icon="el-icon-check"
                        @click="submitForm('form')"
                        >提交</el-button
                    >
                </div>
                
            </el-form-item>

        </el-form>
    </div>
</template>

<script>
import nameSearch from "./name-search.vue";
import CONFIG from '../config/index'

export default {
    components: { nameSearch },
    head: {},
    data() {
        return {
            form: {
                profitname:'',
                productname:'',//产品名称
                producttype:'',//产品类型
                receivers: [//邮箱
                    {
                        value: '',
                    },
                ],
                pushstarttime:'',
                pushendtime:''
            },
            options: CONFIG.bhType
        };
    },
    computed: {
        time: {
            get() {
                let startTime = this.form.pushstarttime	 || '',
                    endTime = this.form.pushendtime;
                    
                if(startTime && endTime){
                    return [
                        startTime,
                        endTime
                    ];   
                } else {
                    return [];
                }
            },
            set(val) {
                if(!val) {
                    this.form.pushstarttime	 = '';
                    this.form.pushendtime = ''
                }else{
                    let startTime = val[0] || '',
                    endTime = val[1] || '';
                    this.form.pushstarttime	 = startTime;
                    this.form.pushendtime = endTime;
                }    
            }
        },
    },
    methods: {
        submitForm(formName) {
            const that = this;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let submitObj = clone(this.form);

                    submitObj.receivers = submitObj.receivers.map(item =>item.value).toString();
                    submitObj.productname = submitObj.productname.toString();
                    submitObj.producttype = submitObj.producttype.toString();

                    this.$confirm('请确认您的邮箱地址填写正确，错误的邮箱地址将导致您无法接收到推送内容', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '我再想想',
                        type: 'warning'
                    }).then(() => {
                        that.$post(`${that.$store.state.api.webUrl}/msgpush/add`,submitObj, (data,res) => {
                            that.$notify({
                                message: data,
                                type: 'success'
                            });
                            that.$emit('close')
                        },true); 
                    })
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        removeEmail(item) {
            var index = this.form.receivers.indexOf(item);
            if (index !== -1) {
                this.form.receivers.splice(index, 1);
            }
        },
        addEmail() {
            this.form.receivers.push({
                value: "",
                key: Date.now(),
            });
        },
        selectChange(val){
            const that = this
            if(!val) {
                this.form.producttype = ""
            }else{
                this.form.producttype = this.options.filter(item => that.form.productname.includes(item.label)).map(item => item.value);
            }
            
        },
    },
    created() {},
    mounted() {
        this.resetForm('form');
    },
};
</script>

<style lang="scss" scoped>
.box {
    .name {
       ::v-deep .el-autocomplete {
           display: block;
       }
    }
    .product {
        ::v-deep .el-select {
           display: block;
           max-width: 500px;
       }
    }
    .demo-dynamic {
        ::v-deep .el-input {
            width: 70%;
        }
    }
    .sumbit-btn {
        width: 50px;
        margin: 0 auto;
    }
}
</style>
